import { tracked } from '@glimmer/tracking';
import Service, { service } from '@ember/service';

export default class PaymentLinkStateService extends Service {
  @service store;
  @service router;

  @tracked paymentLinkSession = null;

  async requirePaymentLinkSession() {
    try {
      let paymentLinkSession = await this.store.adapterFor('payment-link-session').currentSession();

      this.paymentLinkSession = paymentLinkSession;
    } catch (error) {
      if (this._isErrorInvalidSession(error)) {
        return this.router.transitionTo('payment-link.expired');
      }

      throw error;
    }
  }

  _isErrorInvalidSession(error) {
    return (
      Array.isArray(error.errors) &&
      error.errors.length === 1 &&
      error.errors[0].title === 'Invalid session'
    );
  }
}
